module.exports = __webpack_public_path__ + "media/images/logo-header-d12eccdeca126a45e716b508e04f4660.svg";